import { Component } from '@angular/core';

@Component({
  selector: 'app-init-error-overlay',
  standalone: true,
  template: `
    <div class="container">
      <div class="error-message">
        <h2>Oops, something went wrong</h2>
        <p class="subtitle">We couldn't load the page. Please check your connection and try again.</p>
        <button type="button" class="button-outline" (click)="refresh()">Refresh page</button>
      </div>
    </div>
  `,
  styles: [`
    .container {
      position: relative;
      height: 100vh;
      text-align: center;
    }

    .error-message {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .subtitle {
      margin-bottom: 1.5rem;
      color: #6b7280;
    }
  `],
})
export class InitErrorOverlayComponent {
  refresh(): void {
    window.location.reload();
  }
}
